// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2EBPG","label":"CategoryService_label__15Vg2","location":"CategoryService_location__1GYb-"};